import React from "react";

import { makeStyles } from "tss-react/mui";
import { Drawer, DrawerProps, Grid, List } from "@mui/material";
import { Logout } from "@mui/icons-material";

import { SIDE_MENU_DATA } from "components/libComponents/SideMenuData";
import WhitelabelLogo from "../admin/WhitelabelLogo";
import { SideMenuItem } from "./SideMenuItem";
import { useLogout } from "contexts/UserContext";
import { LOGIN } from "routers/routePaths";

const useStyles = makeStyles()((theme) => ({
  content: {
    flex: 1,
    padding: theme.spacing(1, 3),
  },
  linkList: {
    flex: 1,
    overflowY: "scroll",
    "& > ul": {
      padding: 0,
      width: "100%",

      "& > li:last-child": {
        marginTop: theme.spacing(4),
      },
    },
  },
  miniMode: {
    height: "100vh",
    position: "sticky",
    "&& > *": {
      position: "absolute",
    },
    "& > .MuiPaper-root": {
      width: "80%",
      maxWidth: "calc((100vw - 600px)/2)",
      minWidth: "min(calc(80vw), 480px)",
    },
  },
}));

export const SideMenu = ({
  open,
  onClose,
  isProsumer = false,
}: DrawerProps & { isProsumer: boolean }) => {
  const { classes } = useStyles();
  const logout = useLogout();

  return (
    <Drawer open={open} onClose={onClose} className={classes.miniMode}>
      <Grid
        direction="column"
        className={classes.content}
        rowSpacing={3}
        container
      >
        <Grid item container>
          <WhitelabelLogo isHorizontal />
        </Grid>
        <Grid item container className={classes.linkList}>
          <List>
            {SIDE_MENU_DATA.filter(
              (item) =>
                item.display && (item.title !== "Investimentos" || isProsumer)
            ).map(({ title, navigateTo, Icon }) => (
              <SideMenuItem
                title={title}
                navigateTo={navigateTo}
                Icon={Icon}
                key={title}
                onNavigation={onClose}
              />
            ))}
            <SideMenuItem
              title="Sair"
              onNavigation={logout}
              navigateTo={LOGIN}
              Icon={Logout}
            />
          </List>
        </Grid>
      </Grid>
    </Drawer>
  );
};
